import { getListPerizie,getListPerizieUser,deletePerizia  } from "helpers/elba_helper";
import { call, put, takeLatest, delay } from "redux-saga/effects";
import { apiError } from "store/actions";
import { getPerizieSuccess } from "./actions";
import { PERIZIE_GET,PERIZIE_DELETE } from "./actionTypes";

function* ottieniPerizie({ payload }) {
  try {
    const response = yield call(getListPerizie, payload);
    if(response){
      if(response?.status === "error"){
        yield put(apiError(response));
        return;
      }

      yield put(getPerizieSuccess(response?.data))
    }
  } catch (error) {
    yield put(apiError(error?.response?.data));
  }
}
function* deletePeriziaUser({ payload }) {
  try {
    const response = yield call(deletePerizia, payload);
    if(response){
      if(response?.status === "error"){
        yield put(apiError(response));
        return;
      }

      // After successful deletion, fetch the updated list
      // Use the same query parameters as the last fetch
      // For now, fetch the first page with default parameters
      yield put({ type: PERIZIE_GET, payload: { paginate: true, page: 1 } })
    }
  } catch (error) {
    yield put(apiError(error?.response?.data));
  }
}

function* perizieSaga() {
  yield takeLatest(PERIZIE_GET, ottieniPerizie);
  yield takeLatest(PERIZIE_DELETE, deletePeriziaUser);
}
 

  
export default perizieSaga;